.number {
  width: 100%;
}
